import { render } from "./TheAposContextUndoRedo.vue?vue&type=template&id=d83bc2e6&scoped=true"
import script from "./TheAposContextUndoRedo.vue?vue&type=script&lang=js"
export * from "./TheAposContextUndoRedo.vue?vue&type=script&lang=js"

import "./TheAposContextUndoRedo.vue?vue&type=style&index=0&id=d83bc2e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83bc2e6"],['__file',"admin-bar/ui/apos/components/TheAposContextUndoRedo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d83bc2e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d83bc2e6', __exports__)) {
    api.reload('d83bc2e6', __exports__)
  }
  
  module.hot.accept("./TheAposContextUndoRedo.vue?vue&type=template&id=d83bc2e6&scoped=true", () => {
    api.rerender('d83bc2e6', render)
  })

}


export default __exports__